import { getViewLeadManagementActions } from "./action";

const initialState = {
  getViewLeadManagementData: "",
};

const getViewLeadManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case getViewLeadManagementActions.GET_VIEW_LEAD_MANAGEMENT_SUCCESS:
      return {
        ...state,
        getViewLeadManagementData: action.payload.data,
      };
    case getViewLeadManagementActions.GET_VIEW_LEAD_MANAGEMENT_ERROR:
      return {
        ...state,
        getViewLeadManagementData: [],
      };

    default:
      return state;
  }
};

export default getViewLeadManagementReducer;
